import {
  Image,
  ImageBackground,
  Modal,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { AppImages } from "../../../../utility/AppImages";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../../Api/configs";
import { ShowLoader } from "../../../../common/ShowLoader";
import {
  fetchPaymentBeltExchange,
  fetchPaymentRequestSell,
} from "../../../../services/profileAPI";
import { handleApiError } from "../../../../services/errorHandler";
import UpgradeComponent from "../../../../Components/home-common-components/UpgradeComponent";
import { useAuthProvider } from "../../../../context/AuthContext";
import Separator from "../../../../Components/Separator";
import { CommonButton } from "../../../../common/CommonButton";
import TimerComponent from "../../../../Components/ongoing-common-components/general-components/TimerComponent";
import ImageComponent from "../../../../Components/ImageComponent";

export default function AddSocialLink(props) {
  const {
    showModal = false,
    setShowModal,
    links,
    handleUpdateLinks,
    handleLinkChange,
  } = props;
  const [isSaving, setIsSaving] = useState(false);

  const onCloseClick = () => {
    setShowModal(false);
  };

  const [localLinks, setLocalLinks] = useState({ ...links });
  const handleInputChange = (name, text) => {
    let formattedText = text.trim();

    const httpPrefix = "http://";
    const httpsPrefix = "https://";
    let cleanedText = formattedText;

    if (cleanedText.startsWith(httpsPrefix)) {
      cleanedText = cleanedText.substring(httpsPrefix.length);
    } else if (cleanedText.startsWith(httpPrefix)) {
      cleanedText = cleanedText.substring(httpPrefix.length);
    }

    if (cleanedText) {
      formattedText = `https://${cleanedText}`;
    } else {
      formattedText = "";
    }

    setLocalLinks((prev) => ({
      ...prev,
      [name]: formattedText,
    }));
  };
  const handleSave = () => {
    setIsSaving(true);
    handleUpdateLinks(localLinks, () => setIsSaving(false));
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [showLoader, setShowLoader] = useState(false);
  const socialMediaData = [
    {
      name: "instagram",
      placeholder: "https://www.instagram.com/",
      image: AppImages.icSocialInsta,
    },
    {
      name: "youtube",
      placeholder: "https://www.youtube.com/",
      image: AppImages.icSocialYoutube,
    },
    {
      name: "twitch",
      placeholder: "https://www.twitch.com/",
      image: AppImages.icSocialTwitch,
    },
    {
      name: "discord",
      placeholder: "https://www.discord.com/",
      image: AppImages.icSocialDiscord,
    },
    {
      name: "x",
      placeholder: "https://www.x.com/",
      image: AppImages.icSocialTwitter,
    },
    {
      name: "linkedIn",
      placeholder: "https://www.linkedIn.com/",
      image: AppImages.icLinkedIn,
    },
    {
      name: "facebook",
      placeholder: "https://www.facebook.com/",
      image: AppImages.icSocialFacebookSvg,
    },
  ];

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "center",
          }}
          style={styles.scrollView}
        >
          <View style={styles.mainView}>
            {/* Header view */}
            <View
              style={{
                gap:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 12
                    : 22,
              }}
            >
              <View style={styles.headerView}>
                <View
                  style={{
                    flex: 1,
                    alignSelf: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_24, styles.headerText]}
                  >
                    Add social links
                  </Text>
                  <TouchableOpacity onPress={onCloseClick} activeOpacity={0.5}>
                    <Image
                      source={AppImages.icCloseWhite}
                      style={{
                        height: 28,
                        width: 28,
                        resizeMode: "contain",
                      }}
                    />
                  </TouchableOpacity>
                </View>
              </View>
              {/* Social Media Inputs */}
              <ScrollView
                showsHorizontalScrollIndicator={false}
                style={{ maxHeight: 500 }}
              >
                <View
                  style={{
                    gap: 22,
                  }}
                >
                  {socialMediaData.map((item, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        gap: 12,
                        alignItems: "center",
                      }}
                    >
                      <View
                        style={{ gap: 12, width: 65, alignItems: "center" }}
                      >
                        <ImageComponent
                          url={item.image}
                          style={[
                            {
                              resizeMode: "contain",
                              width: 46,
                              height: 47,
                            },
                          ]}
                        />
                        <Text style={AppFontStyle.MEDIUM_ANYBODY_12}>
                          {item.name}
                        </Text>
                      </View>
                      <View style={{ gap: 6, flex: 1 }}>
                        <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>Link</Text>
                        <TextInput
                          placeholder={item.placeholder}
                          multiline={false}
                          placeholderTextColor={AppColors.gray_C4C4C4}
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_16,
                            {
                              color: AppColors.gray_BBB,
                              paddingVertical: 8,
                              paddingHorizontal: 12,
                              backgroundColor: AppColors.black,
                              borderRadius: 8,
                              borderWidth: 1,
                              borderColor: AppColors.gray_5C5C5C,
                            },
                          ]}
                          onSubmitEditing={() => {}}
                          onChangeText={(text) =>
                            handleInputChange(item.name, text)
                          }
                          value={localLinks[item.name] ?? ""}
                          keyboardType="default"
                          secureTextEntry={false}
                        />
                      </View>
                    </View>
                  ))}
                </View>
              </ScrollView>
              <Separator
                color={AppColors.white}
                height={1}
                marginTop={0}
                marginBottom={0}
                marginHorizontal={0}
              />
              <View style={{ alignItems: "flex-end" }}>
                <CommonButton
                  buttonStyle={styles.SaveButtonStyle}
                  textStyle={[AppFontStyle.SEMIBOLD_ANYBODY_14, {}]}
                  title={isSaving ? "Saving" : "Save"}
                  onTap={handleSave}
                  disabled={isSaving}
                />
              </View>
            </View>
          </View>
        </ScrollView>
      </View>

      {<ShowLoader showIndicater={showLoader} />}
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    scrollView: {
      width: "100%",
    },
    mainView: {
      width: "80%",
      maxWidth: 761,
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      marginHorizontal: 40,
      marginVertical: 30,
      alignSelf: "center",
      borderRadius: 24,
      borderWidth: 1,
      borderColor: AppColors.gray_A6A3AA,
    },
    headerView: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 16,
    },
    headerText: {
      color: AppColors.white,
      fontSize: 24,
    },
    SaveButtonStyle: {
      paddingVertical: 10,
      paddingHorizontal: 14,
      shadowOpacity: 0,
      borderRadius: 10,
      height: 35,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      boxShadow: `0px 0px 0px 1px ${AppColors.appViolentColor_6D08C3}`,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "60%",
        maxWidth: "auto",
        padding: 12,
        marginHorizontal: 10,
        marginVertical: 30,
        borderRadius: 12,
      },
      headerText: {
        fontSize: 22,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "90%",
        maxWidth: "auto",
        marginHorizontal: 10,
        marginVertical: 30,
        padding: 12,
        borderRadius: 12,
      },
      headerText: {
        fontSize: 22,
      },
    },
  }
);
